var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTransferIcon = function SvgTransferIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#transfer-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    fillRule: "evenodd",
    d: "M32.845 22.844a1.67 1.67 0 0 1-1.178.489h-3.334a1.666 1.666 0 0 1-1.666-1.667v-8.333h-5a1.667 1.667 0 0 1-1.28-2.734L28.72.6a1.668 1.668 0 0 1 2.56 0l8.334 10a1.666 1.666 0 0 1-1.28 2.734h-5v8.333c0 .442-.176.866-.489 1.178M19.613 29.4l-8.333 10a1.665 1.665 0 0 1-2.56 0l-8.334-10A1.65 1.65 0 0 1 0 28.333a1.667 1.667 0 0 1 1.667-1.667h5v-8.333a1.667 1.667 0 0 1 1.666-1.666h3.333a1.667 1.667 0 0 1 1.667 1.666v8.334h5a1.666 1.666 0 0 1 1.28 2.733",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "transfer-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgTransferIcon;